import type { IntlKey } from 'locales';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { camelCaseToWords } from 'utils/string';

type FormLabel<T extends string> = `form.${T}` extends IntlKey | string ? T : never;
interface SummaryFieldProps<T extends string> {
  labelKey: FormLabel<T>;
  children: ReactNode;

  id: string;
}

export function SummaryFieldRow<T extends string>({ labelKey, children, id }: SummaryFieldProps<T>) {
  return (
    <div className="row">
      <div className="col-5">
        <label className="text-large fw-light text-secondary m-0" id={id}>
          <FormattedMessage id={`form.${labelKey}` as IntlKey} defaultMessage={camelCaseToWords(labelKey)} />
        </label>
      </div>
      <div className="col-7" aria-labelledby={id}>
        {children}
      </div>
    </div>
  );
}
